import React, { useEffect, useState, useRef } from "react";
import {
    Stack,
    Box,
    Button,
    Typography,
    Grid,
    ImageList,
    ImageListItem,
    Divider,
    ImageListItemBar,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Backdrop,
    CircularProgress
} from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import VideoChatIcon from '@mui/icons-material/VideoChat';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import MapIcon from '@mui/icons-material/Map';
import FilePreviewModal from "../tools/Modal";
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ModalInfo from "../tools/ModalInfo";

const live_events_service = require('../../helpers/live_events_service')

const primary = "#0d1e4a";
const dark = "#c9a43b";

const Inicio = () => {
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down("sm"));
    const isMd = useMediaQuery(theme.breakpoints.between("sm", "lg"));
    const isLg = useMediaQuery(theme.breakpoints.up("lg"));

    let cols = 5;
    let cols_detalles = 2;
    if (isXs) { cols = 1; cols_detalles = 1; }
    else if (isMd) { cols = 3; cols_detalles = 2; }
    else if (isLg) { cols = 5; cols_detalles = 2; }

    const stats_arr = [
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/9c616b0a-7c5a-4357-9aae-51584e68cb8d.jpeg", title: "PARTICIPANTES", value: "+250" },
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/91e32109-0226-4148-8f04-3626d422ad6d.jpeg", title: "STANDS EXPO", value: "+12" },
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/5bdf2e7f-e34a-42fa-bde3-8965eb1948ce.png", title: "PAÍSES", value: "Latam" },
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/2c9d0aa6-dfd7-4e85-b551-3d9226de805f.png", title: "SEDE", value: "Guatemala" },
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/2add16c0-f13c-4879-97a8-5c01f6b07632.jpeg", title: "CONFERENCIAS", value: "+14" }
    ]
    const detalles_arr = [
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/d887e158-984e-4537-9d6c-53441c9a2a8a.jpeg", title: "PROGRAMA ACADÉMICO", value: "Click para ver detalles", href: '/programa' },
        { img: "https://escuela-bancaria.s3.us-east-2.amazonaws.com/933f62f1-b423-4097-8d3f-82b2dd1800b6.jpeg", title: "MEDIA PARTNERS", value: "Click para más detalles", href: '/media-partners' },
    ]
    const varios_arr = [
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/52ae58d7-24cc-4954-ae58-e6a33590d9dd.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/f7bce16e-1a2c-4731-a66b-5a91ecc3eeaa.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/d8d7a616-dab4-44e7-853e-0fff815fceeb.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/431f5b17-fa11-4930-b6ef-3f0b1feb573a.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/451f7bb8-1d05-427e-8f18-4e94145c1e86.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/7b9c2c52-6f0d-40e8-acb3-a6d545b2d6a5.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/47129e5f-2a5e-4348-a0d5-752d53d3ecf4.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/620c27f5-eedc-4a94-b052-c3ee2093c749.jpeg",
        "https://escuela-bancaria.s3.us-east-2.amazonaws.com/b6010e2c-5019-4bad-b411-bf8cccc61532.jpeg",
    ]
    const [contador] = useState(0);
    const [evento, setEvento] = useState({});
    const [conferencistas, setConferencistas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [url, setUrl] = useState("");
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [info, setInfo] = useState({ conferencista: "", cv: "", foto: "", puesto: "", institucion: "", bandera: "", pais: "" });

    useEffect(() => {
        live_events_service
            .getData("/evento/view-by-hash/" + process.env.REACT_APP_EVT)
            .then((response_evt) => {
                live_events_service
                    .getData(
                        "/patrocinador/view-by-evento/" +
                        process.env.REACT_APP_EVT
                    )
                    .then((response_patrocinador) => {
                        live_events_service
                            .getData(`/conferencista/read/${process.env.REACT_APP_EVT}`)
                            .then((response) => {
                                setEvento(response_evt.data.response_database.result[0]);
                                setLoading(false);
                                setConferencistas([...new Map(response.data.response.result.filter(item => item.conferencista?.nombre != null).sort((a, b) => a.hora.localeCompare(b.hora)).map(item => [item.conferencista.nombre, item])).values()].filter((item) => item.conferencista.nombre != 'Representante'))
                            })
                            .catch((error) => { console.log(error); });
                    })
                    .catch((error) => { console.log(error); });
            })
            .catch((error) => { console.log(error); });
    }, [contador]);

    return (
        <Stack>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            {/* Hero: Fecha y sede */}
            <Box
                sx={{
                    width: "100%",
                    position: "relative",
                    overflow: "hidden",
                    color: "#fff",
                    background: `linear-gradient(135deg, ${primary} 0%, #081530 55%, #04091c 100%)`,
                    py: { xs: 5, md: 7 },
                    px: { xs: 3, md: 6 },
                    "@keyframes coplaftHeroIn": {
                        from: { opacity: 0, transform: "translateY(24px)" },
                        to: { opacity: 1, transform: "translateY(0)" },
                    },
                    "@keyframes coplaftPinPulse": {
                        "0%, 100%": { transform: "scale(1)", opacity: 1 },
                        "50%": { transform: "scale(1.12)", opacity: 0.85 },
                    },
                }}
            >
                {/* Elementos decorativos */}
                <Box
                    sx={{
                        position: "absolute",
                        top: { xs: -90, md: -110 },
                        right: { xs: -90, md: -70 },
                        width: { xs: 220, md: 300 },
                        height: { xs: 220, md: 300 },
                        borderRadius: "50%",
                        border: "2px solid rgba(201,164,59,0.25)",
                        pointerEvents: "none",
                    }}
                />
                <Box
                    sx={{
                        position: "absolute",
                        bottom: { xs: -120, md: -150 },
                        left: { xs: -80, md: -50 },
                        width: { xs: 260, md: 360 },
                        height: { xs: 260, md: 360 },
                        borderRadius: "50%",
                        border: "2px solid rgba(255,255,255,0.08)",
                        pointerEvents: "none",
                    }}
                />

                <Stack
                    spacing={{ xs: 3, md: 4 }}
                    alignItems="center"
                    sx={{ position: "relative", zIndex: 1, animation: "coplaftHeroIn .8s ease both" }}
                >
                    <Typography
                        sx={{
                            textTransform: "uppercase",
                            letterSpacing: { xs: 2, md: 4 },
                            fontSize: { xs: 11, md: 13 },
                            fontWeight: 600,
                            color: dark,
                            opacity: 0.9,
                            textAlign: "center",
                        }}
                    >
                        COPLAFT 2026 &middot; V Congreso Latinoamericano de Prevención del Lavado de Activos y Financiamiento del Terrorismo
                    </Typography>

                    <Stack
                        direction={{ xs: "column", md: "row" }}
                        spacing={{ xs: 2.5, md: 4 }}
                        alignItems="stretch"
                        justifyContent="center"
                        sx={{ width: "100%", maxWidth: 860 }}
                    >
                        {/* Fecha */}
                        <Stack
                            direction="row"
                            spacing={2}
                            alignItems="center"
                            sx={{
                                flex: 1,
                                backgroundColor: "rgba(255,255,255,0.08)",
                                border: "1px solid rgba(201,164,59,0.4)",
                                borderRadius: 3,
                                px: { xs: 3, md: 4 },
                                py: { xs: 2.25, md: 3 },
                                backdropFilter: "blur(4px)",
                                WebkitBackdropFilter: "blur(4px)",
                                transition: "transform .3s ease, background-color .3s ease",
                                "&:hover": {
                                    transform: "translateY(-4px)",
                                    backgroundColor: "rgba(255,255,255,0.14)",
                                },
                            }}
                        >
                            <CalendarMonthIcon sx={{ fontSize: { xs: 36, md: 46 }, color: dark }} />
                            <Box>
                                <Typography
                                    sx={{
                                        textTransform: "uppercase",
                                        letterSpacing: 2,
                                        fontSize: { xs: 10, md: 12 },
                                        fontWeight: 600,
                                        color: dark,
                                        opacity: 0.85,
                                    }}
                                >
                                    Fecha
                                </Typography>
                                <Typography sx={{ fontWeight: "bold", fontSize: { xs: 20, md: 26 }, lineHeight: 1.2 }}>
                                    21 y 22 de septiembre
                                </Typography>
                                <Typography sx={{ fontSize: { xs: 12, md: 14 }, opacity: 0.85 }}>
                                    2026
                                </Typography>
                            </Box>
                        </Stack>

                        {/* Hotel sede */}
                        <Stack
                            direction="row"
                            spacing={2}
                            alignItems="center"
                            sx={{
                                flex: 1,
                                backgroundColor: "rgba(255,255,255,0.08)",
                                border: "1px solid rgba(201,164,59,0.4)",
                                borderRadius: 3,
                                px: { xs: 3, md: 4 },
                                py: { xs: 2.25, md: 3 },
                                backdropFilter: "blur(4px)",
                                WebkitBackdropFilter: "blur(4px)",
                                transition: "transform .3s ease, background-color .3s ease",
                                "&:hover": {
                                    transform: "translateY(-4px)",
                                    backgroundColor: "rgba(255,255,255,0.14)",
                                },
                            }}
                        >
                            <LocationOnIcon
                                sx={{ fontSize: { xs: 36, md: 46 }, color: dark, animation: "coplaftPinPulse 2.4s ease-in-out infinite" }}
                            />
                            <Box>
                                <Typography
                                    sx={{
                                        textTransform: "uppercase",
                                        letterSpacing: 2,
                                        fontSize: { xs: 10, md: 12 },
                                        fontWeight: 600,
                                        color: dark,
                                        opacity: 0.85,
                                    }}
                                >
                                    Hotel sede
                                </Typography>
                                <Typography sx={{ fontWeight: "bold", fontSize: { xs: 20, md: 26 }, lineHeight: 1.2 }}>
                                    Hotel Barceló
                                </Typography>
                                <Typography sx={{ fontSize: { xs: 12, md: 14 }, opacity: 0.85 }}>
                                    Salón Las Naciones · Ciudad de Guatemala
                                </Typography>
                            </Box>
                        </Stack>
                    </Stack>
                </Stack>
            </Box>

            {/* Título principal */}
            <Box sx={{ width: "100%", px: { xs: '5%', md: '8%', lg: '10%' }, py: { xs: '6%', md: '5%' } }}>
                <Stack spacing={{ xs: 3, md: 6 }}>
                    <Typography
                        variant="h4"
                        sx={{
                            color: dark,
                            fontWeight: "bold",
                            textAlign: 'center',
                            fontSize: { xs: '1.1rem', sm: '1.4rem', md: '1.8rem', lg: '2.125rem' },
                        }}
                    >
                        V CONGRESO LATINOAMERICANO DE PREVENCIÓN DEL LAVADO DE ACTIVOS Y FINANCIAMIENTO DEL TERRORISMO
                    </Typography>
                    <Typography
                        variant="h5"
                        sx={{
                            color: primary,
                            fontWeight: "bold",
                            textAlign: 'center',
                            fontSize: { xs: '0.9rem', sm: '1.1rem', md: '1.3rem' },
                        }}
                    >
                        Protegiendo Nuestro Sistema Financiero y Empresarial
                    </Typography>
                    <Divider />
                    <Typography
                        variant="h5"
                        sx={{
                            color: dark,
                            fontWeight: "bold",
                            mb: 1,
                            textAlign: "center",
                            fontSize: { xs: '1rem', sm: '1.2rem', md: '1.5rem' },
                        }}
                    >
                        Temario Preliminar
                    </Typography>
                    <Typography
                        variant="p"
                        sx={{
                            color: dark,
                            fontWeight: 500,
                            textAlign: "center",
                            margin: "0 auto",
                            lineHeight: 1.6,
                            fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
                        }}
                    >
                        EVALUACIONES MUTUAS Y ACTUALIZACIÓN GAFI
                        · GESTIÓN DE RIESGOS LA/FT EN ENTORNOS CAMBIANTES
                        · TRANSPARENCIA Y BENEFICIARIO FINAL
                        · ECONOMÍAS CRIMINALES Y CONVERGENCIA TRANSNACIONAL
                        · DEEPFAKES, TIKTOK Y TELEGRAM: NUEVAS FRONTERAS DEL FRAUDE
                        · IMPLICACIONES DE LISTA GRIS DE GAFILAT
                        · INTELIGENCIA ARTIFICIAL EN LA PLD/FT
                        · INTELIGENCIA FINANCIERA Y NUEVAS TECNOLOGÍAS
                        · COMPLIANCE INTELIGENTE PARA ECOSISTEMA CRIPTO
                        · USO DE IA EN GESTIÓN DE RIESGO LAFT
                        · PROLIFERACIÓN DE ARMAS Y SANCIONES INTERNACIONALES
                        · EXTORSIÓN EN EL MUNDO DIGITAL
                        · GEOPOLÍTICA GLOBAL Y RIESGOS AML EN LATINOAMÉRICA
                    </Typography>
                </Stack>
            </Box>

            {/*Banner imagen */}
            <Box sx={{ width: "100%" }}>
                <img
                    src='https://escuela-bancaria.s3.us-east-2.amazonaws.com/b2cfeabe-3533-46e1-b153-cee2d114dd8f.jpeg'
                    style={{ width: '100%', display: 'block' }}
                    loading="lazy"
                />
            </Box>

            {/* Video */}
            <Box
                style={{
                    width: '100%',
                    backgroundImage: 'url(https://escuela-bancaria.s3.us-east-2.amazonaws.com/16416305-43f2-45dc-a0a3-7fab9219bcf0.jpeg)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    textAlign: 'center',
                }}
                sx={{ py: { xs: '8%', md: '6%', lg: '5%' }, px: { xs: '5%', md: '10%', lg: '15%' } }}
            >
                <video
                    controls
                    style={{ width: '100%', maxWidth: '900px', display: 'block', margin: '0 auto' }}
                >
                    <source
                        src="https://escuela-bancaria.s3.us-east-2.amazonaws.com/fbc7b995-5222-409c-96f6-cc5af566ee52.mp4"
                        type="video/mp4"
                    />
                </video>
            </Box>

            {/* Texto descriptivo */}
            <Box
                sx={{
                    width: "100%",
                    backgroundColor: primary,
                    px: { xs: '5%', md: '8%', lg: '10%' },
                    py: { xs: '8%', md: '6%', lg: '5%' },
                }}
            >
                <Stack spacing={{ xs: 3, md: 4 }} alignItems="center">
                    {/* Tres pilares */}
                    <Grid container spacing={3} justifyContent="center" sx={{ width: '100%', maxWidth: '900px' }}>
                        {[
                            { label: "Visión compartida", icon: "🔭" },
                            { label: "Cooperación", icon: "🤝" },
                            { label: "Conocimiento", icon: "💡" },
                        ].map((item) => (
                            <Grid key={item.label} size={{ xs: 12, sm: 4 }}>
                                <Box
                                    sx={{
                                        textAlign: 'center',
                                        py: 2,
                                        borderTop: `3px solid ${dark}`,
                                    }}
                                >
                                    <Typography sx={{ fontSize: '2rem', mb: 0.5 }}>{item.icon}</Typography>
                                    <Typography
                                        fontWeight="bold"
                                        sx={{ color: dark, fontSize: { xs: '1rem', md: '1.1rem' } }}
                                    >
                                        {item.label}
                                    </Typography>
                                </Box>
                            </Grid>
                        ))}
                    </Grid>

                    <Divider sx={{ borderColor: 'rgba(201,164,59,0.3)', width: '100%' }} />

                    {/* Descripción */}
                    <Stack spacing={2} sx={{ maxWidth: '820px', width: '100%' }}>
                        <Typography
                            sx={{
                                color: 'rgba(255,255,255,0.92)',
                                textAlign: 'justify',
                                fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' },
                                lineHeight: { xs: 1.7, md: 1.8 },
                            }}
                        >
                            El <strong style={{ color: dark }}>COPLAFT</strong>, organizado por la <strong style={{ color: dark }}>Asociación Bancaria de Guatemala - ABG</strong> en conjunto con la <strong style={{ color: dark }}>Federación Latinoamericana de Bancos - FELABAN</strong>, en su edición 2026 se celebrará en el Hotel Barceló, Ciudad de Guatemala.
                        </Typography>
                        <Typography
                            sx={{
                                color: 'rgba(255,255,255,0.92)',
                                textAlign: 'justify',
                                fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' },
                                lineHeight: { xs: 1.7, md: 1.8 },
                            }}
                        >
                            En el congreso esperamos a más de <strong style={{ color: dark }}>250 participantes</strong> como reguladores, autoridades, sujetos obligados, organismos internacionales y líderes del sector financiero a nivel latinoamericano para analizar y anticiparse a los temas que están marcando la agenda global de cumplimiento.
                        </Typography>
                        <Typography
                            sx={{
                                color: 'rgba(255,255,255,0.92)',
                                textAlign: 'justify',
                                fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' },
                                lineHeight: { xs: 1.7, md: 1.8 },
                            }}
                        >
                            Este es el espacio ideal para construir alianzas, compartir experiencias y fortalecer la unión regional, a través de una logística robusta con áreas de exposición comercial.
                        </Typography>
                    </Stack>
                </Stack>
            </Box>

            {/* Stats ImageList */}
            <ImageList cols={cols} sx={{ m: 0 }}>
                {stats_arr.map((item) => (
                    <ImageListItem key={item.img}>
                        <img
                            srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                            src={`${item.img}?w=248&fit=crop&auto=format`}
                            alt={item.title}
                            loading="lazy"
                        />
                        <ImageListItemBar
                            title={item.title}
                            subtitle={item.value}
                        />
                    </ImageListItem>
                ))}
            </ImageList>

            {/* Precio grupal + Patrocinio */}
            <Grid container alignItems="stretch" justifyContent="center" style={{ width: '100%' }}>
                <Grid size={{ xs: 12, md: 6, lg: 6 }} sx={{ padding: { xs: '8%', sm: '6%', md: '8%', lg: '10%' } }} style={{ backgroundColor: '#0d1e4a' }}>
                    <Stack spacing={2}>
                        <Typography
                            variant="h4"
                            sx={{
                                color: "white",
                                fontWeight: "bold",
                                textAlign: 'justify',
                                fontSize: { xs: '1.3rem', sm: '1.6rem', md: '2rem', lg: '2.125rem' },
                            }}
                        >
                            Precio Especial por Grupos
                        </Typography>
                        <Typography
                            variant="p"
                            sx={{
                                color: "white",
                                fontWeight: "bold",
                                textAlign: 'justify',
                                fontSize: { xs: '0.85rem', md: '1rem' },
                            }}
                        >
                            Reserva para ti y tu equipo el acceso a COPLAFT 2026 con un precio especial por grupos. Asegura tu lugar en el evento de cumplimiento más importante de Latinoamérica y aprovecha esta oferta exclusiva para organizaciones que buscan fortalecer su estrategia de prevención.
                        </Typography>
                        <List style={{ color: 'white' }}>
                            <ListItem disablePadding>
                                <ListItemButton
                                    href={process.env.REACT_APP_URL_INSCRIPCION + process.env.REACT_APP_EVT}
                                    target="_blank"
                                >
                                    <ListItemIcon>
                                        <ShoppingCartIcon style={{ color: 'white' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Inscribirse" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton href="mailto:ncuches@ebg.edu.gt?subject=Quiero%20más%20información%20sobre%20tarifa%20grupal%20de%20COPLAFT%202026">
                                    <ListItemIcon>
                                        <InfoIcon style={{ color: 'white' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Solicitar más información" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton>
                                    <ListItemIcon>
                                        <VideoChatIcon style={{ color: 'white' }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Webinar Open House COPLAFT 2026" />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </Stack>
                </Grid>
                <Grid size={{ xs: 12, md: 6, lg: 6 }} sx={{ padding: { xs: '8%', sm: '6%', md: '8%', lg: '10%' } }}>
                    <Stack spacing={2}>
                        <Typography
                            variant="h4"
                            sx={{
                                color: primary,
                                fontWeight: "bold",
                                textAlign: 'justify',
                                fontSize: { xs: '1.3rem', sm: '1.6rem', md: '2rem', lg: '2.125rem' },
                            }}
                        >
                            Patrocinio
                        </Typography>
                        <Typography
                            variant="p"
                            sx={{
                                color: primary,
                                fontWeight: "bold",
                                textAlign: 'justify',
                                fontSize: { xs: '0.85rem', md: '1rem' },
                            }}
                        >
                            Reserva una de las posiciones disponibles
                        </Typography>
                        <Typography
                            variant="h5"
                            sx={{
                                color: primary,
                                fontWeight: "bold",
                                textAlign: 'justify',
                                fontSize: { xs: '1rem', sm: '1.2rem', md: '1.5rem' },
                            }}
                        >
                            Patrocinador / Stand / Paquetes Especiales
                        </Typography>
                        <List style={{ color: primary }}>
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => { setOpen(true); setUrl(evento.evt_info_pdf) }}>
                                    <ListItemIcon>
                                        <PictureAsPdfIcon style={{ color: primary }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Ver Brief de Patrocinios" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton onClick={() => { setOpen(true); setUrl(evento.planos) }}>
                                    <ListItemIcon>
                                        <MapIcon style={{ color: primary }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Ver Planos de Expo" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton href="mailto:ncuches@ebg.edu.gt?subject=Quiero%20más%20información%20sobre%20patrocinio%20de%20COPLAFT%202026">
                                    <ListItemIcon>
                                        <InfoIcon style={{ color: primary }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Solicitar más información" />
                                </ListItemButton>
                            </ListItem>
                            <ListItem disablePadding>
                                <ListItemButton>
                                    <ListItemIcon>
                                        <VideoChatIcon style={{ color: primary }} />
                                    </ListItemIcon>
                                    <ListItemText primary="Webinar Open House COPLAFT 2026 - Sponsors" />
                                </ListItemButton>
                            </ListItem>
                        </List>
                    </Stack>
                </Grid>
            </Grid>
            <img src='https://escuela-bancaria.s3.us-east-2.amazonaws.com/e799d48c-677c-45e0-811f-a33803d03622.jpeg' style={{ width: '100%' }} />
            {/* Hero: DIRIGIDO A */}
            <Box
                sx={{
                    width: "100%",
                    minHeight: { xs: 'auto', md: '500px', lg: '600px' },
                    position: "relative",
                    backgroundImage: `url("https://escuela-bancaria.s3.us-east-2.amazonaws.com/53a78163-a027-4504-833e-91fb7b69d022.jpeg")`,
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        backdropFilter: "blur(3px)",
                        WebkitBackdropFilter: "blur(3px)",
                        backgroundColor: "rgba(13,30,74,0.6)",
                        zIndex: 1,
                    }}
                />
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 2,
                        px: { xs: '5%', sm: '8%', md: '10%', lg: '15%' },
                        py: { xs: '8%', sm: '6%', md: '5%' },
                    }}
                >
                    <Stack spacing={1}>
                        <Typography
                            variant="h3"
                            fontWeight="bold"
                            color="white"
                            gutterBottom
                            sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem', lg: '3rem' } }}
                        >
                            DIRIGIDO A:
                        </Typography>
                        <Typography
                            variant="p"
                            fontWeight="bold"
                            color={primary}
                            gutterBottom
                            sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}
                        >
                            Sector Financiero y Empresarial
                        </Typography>
                        <Typography
                            variant="p"
                            color="white"
                            sx={{
                                maxWidth: "600px",
                                opacity: 0.9,
                                textAlign: 'justify',
                                fontSize: { xs: '0.8rem', sm: '0.85rem', md: '1rem' },
                                lineHeight: { xs: 1.6, md: 1.7 },
                            }}
                            gutterBottom
                        >
                            Reguladores, autoridades, sujetos obligados, organismos internacionales y líderes del sector financiero a nivel latinoamericano. Compliance officers, analistas de cumplimiento, monitoreo, prevención de fraudes, auditores, financieros, consejos de administración, comités de cumplimiento, supervisores, gestores de riesgo y todos los actores del ecosistema AML/CFT de la región.
                        </Typography>
                    </Stack>
                </Box>
            </Box>

            {/* Detalles ImageList */}
            <ImageList cols={cols_detalles} sx={{ m: 0 }}>
                {detalles_arr.map((item) => (
                    <ImageListItem key={item.img}>
                        <img
                            srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                            src={`${item.img}?w=248&fit=crop&auto=format`}
                            alt={item.title}
                            loading="lazy"
                            style={{
                                height: isXs ? '250px' : '500px',
                                objectFit: 'cover',
                            }}
                        />
                        <ImageListItemBar
                            title={item.title}
                            subtitle={item.value}
                            actionIcon={
                                <IconButton
                                    sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                    aria-label={`info about ${item.title}`}
                                    href={item.href}
                                >
                                    <InfoIcon />
                                </IconButton>
                            }
                        />
                    </ImageListItem>
                ))}
            </ImageList>

            {/* Hero: COPLAFT 2026 */}
            <Box
                sx={{
                    width: "100%",
                    minHeight: { xs: 'auto', md: '500px', lg: '600px' },
                    position: "relative",
                    backgroundImage: `url("https://escuela-bancaria.s3.us-east-2.amazonaws.com/2cdb630b-7fe3-43ec-a0fe-10288be8da1a.jpeg")`,
                    backgroundSize: "cover",
                    backgroundPosition: "center top",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        backdropFilter: "blur(3px)",
                        WebkitBackdropFilter: "blur(3px)",
                        backgroundColor: "rgba(13,30,74,0.6)",
                        zIndex: 1,
                    }}
                />
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 2,
                        px: { xs: '5%', sm: '8%', md: '10%', lg: '15%' },
                        py: { xs: '8%', sm: '6%', md: '5%' },
                    }}
                >
                    <Stack spacing={1}>
                        <Typography
                            variant="h3"
                            fontWeight="bold"
                            color="white"
                            gutterBottom
                            sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem', lg: '3rem' } }}
                        >
                            COPLAFT 2026
                        </Typography>
                        <Typography
                            variant="p"
                            fontWeight="bold"
                            color={primary}
                            gutterBottom
                            sx={{ fontSize: { xs: '0.9rem', md: '1rem' } }}
                        >
                            +12 expositores
                        </Typography>
                        <Typography
                            variant="p"
                            color="white"
                            sx={{
                                maxWidth: "600px",
                                opacity: 0.9,
                                textAlign: 'justify',
                                fontSize: { xs: '0.8rem', sm: '0.85rem', md: '1rem' },
                                lineHeight: { xs: 1.6, md: 1.7 },
                            }}
                            gutterBottom
                        >
                            Soluciones en AML/CFT, Inteligencia Artificial aplicada al Compliance, Monitoreo Transaccional, Ciberseguridad, Gestión de Riesgos, Sanciones Internacionales, Activos Virtuales y tecnologías emergentes que fortalecerán la prevención y el cumplimiento en tu institución.

                            Conecta con proveedores especializados, expertos internacionales y líderes del sector financiero de toda Latinoamérica en COPLAFT 2026.
                        </Typography>
                    </Stack>
                </Box>
            </Box>

            {/* Conferencistas — solo visible cuando hay datos */}
            {conferencistas.length > 0 && (
                <Box sx={{ width: "100%", px: { xs: '3%', md: '4%', lg: '5%' }, py: { xs: '6%', md: '5%' }, overflow: 'hidden' }}>
                    <Stack spacing={{ xs: 3, md: 6 }}>
                        <Typography
                            variant="h4"
                            sx={{
                                color: dark,
                                fontWeight: "bold",
                                textAlign: 'center',
                                fontSize: { xs: '1.2rem', sm: '1.5rem', md: '2rem', lg: '2.125rem' },
                            }}
                        >
                            NUESTROS CONFERENCISTAS
                        </Typography>
                        <Divider />
                        <ImageList
                            cols={cols}
                            rowHeight={isXs ? 220 : isMd ? 240 : 280}
                        >
                            {conferencistas.map((item) => (
                                <ImageListItem
                                    key={item.conferencista.foto}
                                    sx={{
                                        borderRadius: 3,
                                        overflow: "hidden",
                                        cursor: "pointer",
                                        position: "relative",
                                        transition: "box-shadow 0.3s ease",
                                        "&:hover": {
                                            boxShadow: "0 0 20px rgba(201, 164, 59, 0.8)",
                                        },
                                        "&:hover img": {
                                            filter: "brightness(1.05)",
                                        },
                                    }}
                                >
                                    <img
                                        srcSet={`${item.conferencista.foto}?w=248&fit=crop&auto=format&dpr=2 2x`}
                                        src={`${item.conferencista.foto}?w=248&fit=crop&auto=format`}
                                        alt={item.conferencista.nombre}
                                        loading="lazy"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            display: "block",
                                            transition: "filter 0.3s ease",
                                            filter: "grayscale(100%)",
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.filter = "grayscale(0%)")}
                                        onMouseLeave={(e) => (e.currentTarget.style.filter = "grayscale(100%)")}
                                    />
                                    <ImageListItemBar
                                        title={item.conferencista.nombre}
                                        sx={{
                                            background: "linear-gradient(to top, rgba(13,30,74,0.9), rgba(13,30,74,0.2))",
                                            '& .MuiImageListItemBar-title': {
                                                fontSize: { xs: '0.75rem', md: '0.875rem' },
                                            },
                                        }}
                                        actionIcon={item.conferencista.cv &&
                                            <IconButton
                                                sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                                aria-label={`info about ${item.conferencista.nombre}`}
                                                onClick={() => {
                                                    setInfo({
                                                        conferencista: item.conferencista.nombre,
                                                        cv: item.conferencista.cv,
                                                        foto: item.conferencista.foto,
                                                        puesto: item.conferencista.puesto,
                                                        institucion: item.conferencista.institucion,
                                                        bandera: item.conferencista.bandera,
                                                        pais: item.conferencista.pais
                                                    })
                                                    setModalOpen(true);
                                                }}
                                            >
                                                <InfoIcon />
                                            </IconButton>
                                        }
                                    />
                                </ImageListItem>
                            ))}
                        </ImageList>
                    </Stack>
                </Box>
            )}

            {/* Galería woven */}
            <ImageList
                variant="woven"
                cols={isXs ? 2 : 3}
                gap={isXs ? 4 : 8}
                sx={{ m: 0 }}
            >
                {varios_arr.map((item) => (
                    <ImageListItem key={item}>
                        <img
                            srcSet={`${item}?w=161&fit=crop&auto=format&dpr=2 2x`}
                            src={`${item}?w=161&fit=crop&auto=format`}
                            alt={"varios"}
                            loading="lazy"
                        />
                    </ImageListItem>
                ))}
            </ImageList>

            {/* Hero: Sobre el Congreso */}
            <Box
                sx={{
                    width: "100%",
                    minHeight: { xs: 'auto', md: '500px', lg: '600px' },
                    position: "relative",
                    backgroundImage: `url("https://escuela-bancaria.s3.us-east-2.amazonaws.com/a74f005a-8c6a-41ec-9c85-bb3aa7268f02.png")`,
                    backgroundSize: "cover",
                    backgroundPosition: "center center",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        inset: 0,
                        backdropFilter: "blur(3px)",
                        WebkitBackdropFilter: "blur(3px)",
                        backgroundColor: "rgba(13,30,74,0.6)",
                        zIndex: 1,
                    }}
                />
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 2,
                        px: { xs: '5%', sm: '8%', md: '10%', lg: '15%' },
                        py: { xs: '8%', sm: '6%', md: '5%' },
                        width: '100%',
                    }}
                >
                    <Stack spacing={1}>
                        <Typography
                            variant="h3"
                            fontWeight="bold"
                            color="white"
                            gutterBottom
                            sx={{ fontSize: { xs: '1.5rem', sm: '2rem', md: '2.5rem', lg: '3rem' } }}
                        >
                            Estructura del Congreso
                        </Typography>
                        <Typography
                            variant="p"
                            fontWeight="bold"
                            color={dark}
                            gutterBottom
                            sx={{ fontSize: { xs: '0.8rem', sm: '0.85rem', md: '1rem' } }}
                        >
                            21 y 22 de septiembre del 2026 · Salón Las Naciones, Hotel Barceló
                        </Typography>
                        <Typography
                            variant="p"
                            color="white"
                            sx={{
                                maxWidth: "600px",
                                opacity: 0.9,
                                textAlign: 'justify',
                                fontSize: { xs: '0.8rem', sm: '0.85rem', md: '1rem' },
                            }}
                            gutterBottom
                        >
                            Expo de los Patrocinadores · Conferencias · Foros Técnicos · Coffee break y almuerzo
                        </Typography>
                        <Grid container alignItems="center" justifyContent="flex-start" style={{ width: '100%' }} spacing={2}>
                            <Grid size={{ xs: 12, sm: 8, md: 6, lg: 6 }}>
                                <Button
                                    style={{ backgroundColor: dark, color: 'white' }}
                                    startIcon={<EmailIcon />}
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    href="mailto:ncuches@ebg.edu.gt?subject=Quiero%20más%20información%20sobre%20COPLAFT%202026"
                                    sx={{ fontSize: { xs: '0.75rem', md: '0.875rem' } }}
                                >
                                    Solicitar más información
                                </Button>
                            </Grid>
                        </Grid>
                    </Stack>
                </Box>
            </Box>

            <FilePreviewModal open={open} onClose={() => setOpen(false)} url={url} title="Vista previa" />
            <ModalInfo open={modalOpen} onClose={() => { setModalOpen(false) }} conferencista={info} />
        </Stack>
    );
};

export default Inicio;
